import { supabase } from '@/integrations/supabase/client';

export interface UserReport {
  id?: string;
  reported_user_id: string;
  reported_by: string;
  report_type: string;
  description: string;
  evidence?: any;
  status?: string;
  priority?: string;
  created_at?: string;
  assigned_to?: string;
  reviewed_by?: string;
  reviewed_at?: string;
  updated_at?: string;
  resolution?: string;
}

export const reportService = {
  async submitUserReport(report: Omit<UserReport, 'id' | 'created_at'>): Promise<UserReport> {
    const { data, error } = await supabase
      .from('user_reports')
      .insert({
        reported_user_id: report.reported_user_id,
        reported_by: report.reported_by,
        report_type: report.report_type,
        description: report.description,
        evidence: report.evidence || {},
        status: 'pending',
        priority: 'normal'
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async getUserReports(userId: string): Promise<UserReport[]> {
    const { data, error } = await supabase
      .from('user_reports')
      .select('*')
      .eq('reported_by', userId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getReportsForUser(userId: string): Promise<UserReport[]> {
    const { data, error } = await supabase
      .from('user_reports')
      .select('*')
      .eq('reported_user_id', userId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  }
};